import { AppDefinition } from '../../types/apps';

export const MediaGenAppDefinition: AppDefinition = {
  appId: 'mediagen',
  name: 'Media Generator',
  version: '1.0.0',
  description: 'Generate images and media with templates, profiles, and wizards',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Palette',
    phosphorWeight: 'duotone',
    color: '#ec4899',
  },
  supportedFileTypes: [],
  events: {},
  entityTypes: [
    'MediaGen.Template',
    'MediaGen.Seed',
    'MediaGen.Profile.Character',
    'MediaGen.Profile.Brand',
    'MediaGen.RenderJob.Image',
    'MediaGen.Asset.Image'
  ],
  component: 'MediaGenApp',
  requiresProps: false,
  requiresEntity: false,
  actions: {},
  experimental: true,
  hidden: true,
};



